module.exports = require('./dist/cjs/editing/index');
